module.exports = __webpack_public_path__ + "img/动漫樱花.ccd3b798.png";